import { createSlice } from "@reduxjs/toolkit";
import {
    getChat,
    addChat,
    deleteChat,
    bookmarkChat,
    fetchChatUsers,
    fetchChatRooms,
    createDirectChatRoom,
    fetchRoomMessages,
    sendChatMessage,
    deleteChatMessage,
    markChatMessagesAsRead,
    updateUserOnlineStatus,
    fetchUserOnlineStatus
} from './thunk';

export const initialState = {
    chats: [],
    errors: {},
    users: [],
    rooms: [],
    currentRoom: null,
    messages: [],
    onlineStatus: null,
    loading: false
};

const ChatSlice = createSlice({
    name: 'Chat',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getChat.fulfilled, (state: any, action: any) => {
            state.chats = action.payload;
        });
        builder.addCase(getChat.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || 'Failed to get chat';
        });
        builder.addCase(addChat.fulfilled, (state: any, action: any) => {
            state.chats.map((item: any) => item.usermessages.push(action.payload));
        });
        builder.addCase(addChat.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || 'Failed to add chat';
        });
        builder.addCase(deleteChat.fulfilled, (state: any, action: any) => {
            state.chats = (state.chats || []).map((data: any) => {
                const updatedUserMessages = data.usermessages.filter((message: any) => message.id.toString() !== action.payload.toString());
                return { ...data, usermessages: updatedUserMessages };
            });

        });
        builder.addCase(deleteChat.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || 'Failed to delete chat';
        });

        builder.addCase(bookmarkChat.fulfilled, (state: any, action: any) => {
            state.chats = (state.chats || []).map((data: any) => {
                const updatedUserMessages = data.usermessages.map((message: any) => {
                    if (message.id.toString() === action.payload.toString()) {
                        const bookmark = message.bookmark === true ? false : true;
                        return { ...message, bookmark: bookmark };
                    }
                    return message;
                });

                return { ...data, usermessages: updatedUserMessages };
            });
        });
        builder.addCase(bookmarkChat.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || 'Failed to bookmark chat';
        });

        // New chat reducers
        builder.addCase(fetchChatUsers.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(fetchChatUsers.fulfilled, (state: any, action: any) => {
            state.loading = false;
            if (action.payload?.status) {
                state.users = action.payload.data;
            }
        });
        builder.addCase(fetchChatUsers.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload?.error || action.error?.message || 'Failed to fetch chat users';
        });

        builder.addCase(fetchChatRooms.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(fetchChatRooms.fulfilled, (state: any, action: any) => {
            state.loading = false;
            if (action.payload?.status) {
                state.rooms = action.payload.data;
            }
        });
        builder.addCase(fetchChatRooms.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload?.error || action.error?.message || 'Failed to fetch chat rooms';
        });

        builder.addCase(createDirectChatRoom.fulfilled, (state: any, action: any) => {
            if (action.payload?.status) {
                state.currentRoom = action.payload.data;
            }
        });

        builder.addCase(fetchRoomMessages.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(fetchRoomMessages.fulfilled, (state: any, action: any) => {
            state.loading = false;
            if (action.payload?.status) {
                state.messages = action.payload.data;
            }
        });
        builder.addCase(fetchRoomMessages.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload?.error || action.error?.message || 'Failed to fetch room messages';
        });

        builder.addCase(sendChatMessage.fulfilled, (state: any, action: any) => {
            if (action.payload?.status) {
                state.messages.push(action.payload.data);
            }
        });

        builder.addCase(deleteChatMessage.fulfilled, (state: any, action: any) => {
            if (action.payload?.status) {
                state.messages = state.messages.filter((msg: any) => msg.id !== action.payload.data);
            }
        });

        builder.addCase(markChatMessagesAsRead.fulfilled, (state: any, action: any) => {
            // Update read status in rooms
        });

        builder.addCase(updateUserOnlineStatus.fulfilled, (state: any, action: any) => {
            if (action.payload?.status) {
                state.onlineStatus = action.payload.data;
            }
        });

        builder.addCase(fetchUserOnlineStatus.fulfilled, (state: any, action: any) => {
            if (action.payload?.status) {
                state.onlineStatus = action.payload.data;
            }
        });
    }
});

export default ChatSlice.reducer;